import { isEmpty } from 'mc-ui-utils';
import { hasUserLikedGlance } from './khazaddumbridge';
const key_liked = 'liked_glaces';
export const toggleLikeGlance = (glanceId) => {
    const likedGlances = JSON.parse(localStorage.getItem(key_liked)) || [];
    let newList = likedGlances;
    if (likedGlances.includes(glanceId)) {
        newList = newList.filter((item) => item !== glanceId);
    }
    else {
        newList.push(glanceId);
    }
    newList = [...new Set(newList)];
    localStorage.setItem(key_liked, JSON.stringify(newList));
    return newList.includes(glanceId);
};
export const checkUserHasLiked = (glanceId) => {
    const likedGlances = JSON.parse(localStorage.getItem(key_liked)) || [];
    const newList = likedGlances;
    return newList.includes(glanceId);
};
export const groupedBubbles = (bubbleData, allGlances
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
    let totalGlances = 0;
    const glanceIds = [];
    const bubbles = [];
    if (!isEmpty(bubbleData)) {
        bubbleData.forEach((data, index) => {
            const { bubbleProperties, bubbleContent } = data;
            if (!isEmpty(bubbleContent)) {
                bubbleContent.forEach((story) => {
                    if (story.type !== 5 /* GOOGLE_NATIVE_AD */ &&
                        story.type !== 7 /* IMA_AD */ &&
                        !allGlances.has(story.glanceId)) {
                        if (isEmpty(bubbles[index])) {
                            bubbles[index] = Object.assign({ glances: [] }, bubbleProperties);
                        }
                        story.hasUserLiked = hasUserLikedGlance(story.glanceId);
                        allGlances.add(story.glanceId);
                        glanceIds.push(story.glanceId);
                        const currentBubble = bubbles[index];
                        currentBubble.glances.push(story);
                        totalGlances = totalGlances + 1;
                    }
                });
            }
        });
    }
    const newBubbles = bubbles.filter((bubble) => !isEmpty(bubble));
    return { bubbles: newBubbles, totalGlances, glanceIds };
};
//# sourceMappingURL=bubble.js.map